import axios from "axios";
import no_preview from '../static/images/no_preview.svg';
import { toast } from 'react-toastify';
import { FiAlertCircle, FiAlertTriangle, FiInfo } from "react-icons/fi";

import { ReactComponent as AmericanExpressLogo } from '../static/images/payment_methods/american_express.svg';
import { ReactComponent as DinersClubLogo } from '../static/images/payment_methods/diners_club.svg';
import { ReactComponent as DiscoverLogo } from '../static/images/payment_methods/discover.svg';
import { ReactComponent as JCBLogo } from '../static/images/payment_methods/jcb.svg';
import { ReactComponent as MastercardLogo } from '../static/images/payment_methods/mastercard.svg';
import { ReactComponent as PaypalLogo } from '../static/images/payment_methods/paypal.svg';
import { ReactComponent as UnionPayLogo } from '../static/images/payment_methods/unionpay.svg';
import { ReactComponent as VisaLogo } from '../static/images/payment_methods/visa.svg';
import { ReactComponent as WhiteLabelLogo } from '../static/images/payment_methods/white_label.svg';

import placeholder from '../static/images/placeholder.png';

export const DEFAULT_IMAGE_FALLBACK = placeholder

export const getUser = () => {
    const userStr = localStorage.getItem("user");
    if (userStr) return JSON.parse(userStr);
    else return null;
}

export const getToken = () => {
    return localStorage.getItem("token") || null;
}

export const getExpiry = () => {
    return localStorage.getItem("expiry") || null;
}

export const setUserSession = (token = false, expiry = false, user = false) => {
    if (token) {
        localStorage.setItem("token", token);
    }
    if (expiry) {
        localStorage.setItem("expiry", expiry);
        axios.defaults.headers.common['Authorization'] = 'Token ' + token;
    }
    if (user) {
        localStorage.setItem("user", JSON.stringify(user));
    }
}

export const removeUserSession = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("expiry");
    axios.defaults.headers.common['Authorization'] = null
    localStorage.removeItem("user");
}


export const getPlayerId = () => {
    return '12345678-1234-1234-1234-123456789012'
}
export const getPreviewUrl = (caseObject, type, is_thumbnail, size = "78x45") => {
    let result = ''
    if (caseObject.verinfo) {
        result = is_thumbnail ? caseObject.verinfo[`preview_${type}_${size}`] : caseObject.verinfo[`preview_${type}`]
    }
    if (!result) {
        result = no_preview
    }
    return result
}

export const getSelectedPreviewUrl = (caseObject, is_thumbnail, size = "78x45") => {
    let type;
    if (caseObject.verinfo) {
        type = caseObject.verinfo.selected_preview
    }
    type = type || 'sagittal'
    const result = getPreviewUrl(caseObject, type, is_thumbnail, size)
    return result
}


export const readFileAsync = (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
            resolve(reader.result);
        };

        reader.onerror = reject;

        reader.readAsArrayBuffer(file);
    })
}

export const getAsByteArray = async (file) => {
    return new Uint8Array(await readFileAsync(file))
}

export const getColorInfo = (fullHex) => {
    const color_hex = fullHex.substr(0, 7)
    const opacity_hex = fullHex.substr(7)
    const opacity_percentage = Math.round(parseInt(opacity_hex, 16) / 255 * 100)
    return {
        'color_hex': color_hex,
        'opacity_percentage': opacity_percentage
    }
}

export const convertToRGB = (color_hex) => {
    const hex = color_hex.substring(1)
    const aRgbHex = hex.match(/.{1,2}/g);
    const aRgb = [
        parseInt(aRgbHex[0], 16),
        parseInt(aRgbHex[1], 16),
        parseInt(aRgbHex[2], 16)
    ];
    return aRgb;
}

export const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};


export const getRandomColor = () => {
    return '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
}

export const get8DigitHex = (color_hex, opacity_percentage) => {
    let opacity_hex = Math.round(+(opacity_percentage / 100) * 255).toString(16)
    opacity_hex = opacity_hex.length === 1 ? "0" + opacity_hex : opacity_hex
    return `${color_hex}${opacity_hex}`
}

export const getMonthDifference = (startDate, endDate) => {
    return (
        endDate.getMonth() -
        startDate.getMonth() +
        12 * (endDate.getFullYear() - startDate.getFullYear())
    );
}

export const getDateString = (date) => {
    // return date.toLocaleDateString("it-IT", { day: '2-digit', month: '2-digit', year: '2-digit' })
    let monthNames =["Jan","Feb","Mar","Apr",
                      "May","Jun","Jul","Aug",
                      "Sep", "Oct","Nov","Dec"];

    let day = date.getDate();
    
    let monthIndex = date.getMonth();
    let monthName = monthNames[monthIndex];
    
    let year = date.getFullYear();
    
    return `${day} ${monthName} ${year}`;
}

export const getExtendedDateString = (date) => {
    // return date.toLocaleDateString("it-IT", { day: '2-digit', month: '2-digit', year: '2-digit' })
    let monthNames =["January","February","March","April",
                      "May","June","July","August",
                      "September", "October","November","December"];

    let day = date.getDate();
    
    let monthIndex = date.getMonth();
    let monthName = monthNames[monthIndex];
    
    let year = date.getFullYear();
    
    return `${monthName} ${day}, ${year}`;
}

export const getDateTimeString = (datetime) => {
    const dateString = getDateString(datetime)
    const hours = datetime.getHours().toString().padStart(2, '0')
    const minutes = datetime.getMinutes().toString().padStart(2, '0')
    const timeString = `${hours}:${minutes}`
    return `${dateString}, ${timeString}`;
}

export const isToday = (someDate) => {
    const today = new Date()
    return someDate.getDate() === today.getDate() &&
        someDate.getMonth() === today.getMonth() &&
        someDate.getFullYear() === today.getFullYear()
}

export const getTotalCustomSegmentationsNumber = (license) => {
    let total = 0
    total += license.available_abdominal_surgery
    total += license.available_thoracic_surgery
    total += license.available_maxillofacial_surgery
    total += license.available_vascular_surgery
    total += license.available_oncological_surgery
    total += license.available_cardiac_surgery
    total += license.available_odontology
    total += license.available_orthopedics
    total += license.available_ophthalmology
    return total
}

export const getAvailableCustomSegmentations = (license) => {
    const available_segmentations = {
        'Abdominal surgery': license.available_abdominal_surgery,
        'Thoracic surgery': license.available_thoracic_surgery,
        'Maxillofacial surgery': license.available_maxillofacial_surgery,
        'Vascular surgery': license.available_vascular_surgery,
        'Oncological surgery': license.available_oncological_surgery,
        'Cardiac surgery': license.available_cardiac_surgery,
        'Odontology': license.available_odontology,
        'Orthopedics': license.available_orthopedics,
        'Ophthalmology': license.available_ophthalmology,
    }
    for (const [key, value] of Object.entries(available_segmentations)) {
        if (value === 0 || !value) { delete available_segmentations[key] }
    }
    return available_segmentations
}
 
export const getLicenseRemainingTime = (end_date) => {
    const license_expiration = new Date(end_date + 'T23:59:59')
    const now_in_rome = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Rome' }))
    const remaining_time = license_expiration - now_in_rome
    return remaining_time
}

export const getLicenseRemainingDays = (end_date) => {
    const remaining_time = getLicenseRemainingTime(end_date)
    const remaining_days = Math.floor((remaining_time) / (1000 * 60 * 60 * 24))
    return remaining_days
}

export const isLicenseExpired = () => {
    const user = getUser()
    const remaining_time = getLicenseRemainingTime(user.license_end_date)
    return remaining_time < 0
}

export const isMobile = () => {
    let isMobile = false;
    // (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) isMobile = true;})(navigator.userAgent||navigator.vendor||window.opera);
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) isMobile = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return isMobile
}

export const getQuerystring = (name, url = window.location.href) => {
    const parsedName = name.replace(/[[]]/g, "\\$&");
    const regex = new RegExp(`[?&]${parsedName}(=([^&#]*)|&|#|$)`, "i");
    const results = regex.exec(url);

    if (!results || !results[2]) {
        return false;
    }

    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/**
 * 
 * @param {['success', 'warning', 'error']} type
 * @param {*} text 
 * @param {*} dismissAll 
 */
 export const addToast = (type, text, dismissAll = false) => {
    if (dismissAll) {
        toast.dismiss()
    }
    switch (type) {
        case 'success':
            toast.success(text, {
                icon: <FiInfo size={'20px'} />,
                containerId: 'global'
            });
            break;
        case 'warning':
            toast.warning(text, {
                icon: <FiAlertTriangle size={'20px'} />,
                autoClose: false,
                containerId: 'global'
            });
            break;
        case 'error':
            toast.error(text, {
                icon: <FiAlertCircle size={'20px'} />,
                autoClose: false,
                containerId: 'global'
            });
            break;
        default:
            break;
    }
}

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const removeUnderscores = (string) => {
    return string.replace('_', ' ');
}

export const priceToString = (number) => {
    return (Math.round(number * 100) / 100).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
}

export const priceInCentsToString = (number) => {
    return (Math.round(number) / 100).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
}

export const getBrandImage = (brandName) => {
    switch (brandName) {
        case 'paypal':
            return <PaypalLogo />
        case 'amex':
            return <AmericanExpressLogo />
        case 'diners':
            return <DinersClubLogo />
        case 'discover':
            return <DiscoverLogo />
        case 'jcb':
            return <JCBLogo />
        case 'mastercard':
            return <MastercardLogo />
        case 'unionpay':
            return <UnionPayLogo />
        case 'visa':
            return <VisaLogo />
        case 'unknown':
            return <WhiteLabelLogo />
        default:
            return <WhiteLabelLogo />
    }
}

export const hideEmail = (email) => {
    const email_splitted = email.split("@")
    let masked_email;
    if (email_splitted.length === 2) {
        if (email_splitted[0].length > 2) {
            const first_letter = email_splitted[0].slice(0,1)
            const last_letter = email_splitted[0].slice(-1)
            const mask = "*".repeat(email_splitted[0].length - 2)
            masked_email = first_letter + mask + last_letter + "@" + email_splitted[1]
        }else{
            const mask = "*".repeat(email_splitted[0].length)
            masked_email = mask +  "@" + email_splitted[1]
        }
        return masked_email;
    }
};

export const objectsEqual = (o1, o2) =>
    Object.keys(o1).length === Object.keys(o2).length 
        && Object.keys(o1).every(p => o1[p] === o2[p]);

export const objectListsEqual = (left, right) => {
    const onlyInLeft = left.filter(leftValue => !right.some(rightValue => objectsEqual(leftValue, rightValue)));
    const onlyInRight = right.filter(rightValue => !left.some(leftValue => objectsEqual(rightValue, leftValue)));
    return onlyInLeft.length === 0 && onlyInRight.length === 0
}

export const getRandomPWD = (length = 12) => {
    const upperCase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lowerCase = "abcdefghijklmnopqrstuvwxyz";
    const digits = "0123456789";
    const special = "-_!\"#$%&'*+,./:;=?@\\^`|~[]{}()<>";
    const all = upperCase + lowerCase + digits + special;
    let secret = "";
    for (let i = 0; i < length; i++) {
        secret += getRandomCharFromString(all)
    }
    const targetPosition = getRandomIntegerBetweenZeroAndX(12)
    const randomSpecialChar = getRandomCharFromString(special)
    secret = replaceCharInString(secret, targetPosition, randomSpecialChar)
    return secret
}

const getRandomNumberBetweenZeroAndOne = () => {
    const randomNumber = crypto.getRandomValues(new Uint32Array(1))[0];
    return randomNumber / 0x100000000;
}

const getRandomIntegerBetweenZeroAndX = (x) => {
    const randomNumber = getRandomNumberBetweenZeroAndOne()
    return Math.floor(randomNumber * x);
}

const getRandomCharFromString = (string) => {
    const targetCharIndex = getRandomIntegerBetweenZeroAndX(string.length)
    return string[targetCharIndex];
}

const replaceCharInString = (string, index, char) => {
    return string.slice(0, index) + char + string.slice(index + 1)
}